import { Link } from 'react-router-dom';
import { 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaFacebook,
  // FaTwitter,
  FaLinkedin,
  FaInstagram,
  // FaYoutube,
  FaShieldAlt,
  FaCertificate,
  FaAward
} from 'react-icons/fa';
import logo from '../images/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-container">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-brand">
              <img src={logo} alt="Loan Made Easy Logo" className="footer-logo" />
              <h3>Loan Made Easy</h3>
            </div>
            <p className="footer-description">
              Your trusted partner for all loan requirements. We provide fast, secure, and reliable 
              financial solutions with competitive rates and exceptional customer service.
            </p>
            <div className="footer-certifications">
              <div className="cert-item">
                <FaShieldAlt />
                <span>SSL Secured</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Loan Products</Link></li>
              <li><Link to="/apply">Apply Now</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div>

          {/* Loan Products */}
          <div className="footer-section">
            <h4>Loan Products</h4>
            <ul className="footer-links">
              <li><Link to="/services">Personal Loan</Link></li>
              <li><Link to="/services">Home Loan</Link></li>
              <li><Link to="/services">Car Loan</Link></li>
              <li><Link to="/services">Business Loan</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Us</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FaPhone />
                <div>
                  <span>Customer Care</span>
                  <p>+91 91489 42560</p>
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope />
                <div>
                  <span>Email Support</span>
                  <p>Loanmadeeasy.socials@gmail.com</p>
                </div>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <div>
                  <span>Head Office</span>
                  <p>Bommanahali No. 234 Behind Ganesh Temple, Bangalore - 560076</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Social Media & Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-container">
            <div className="footer-bottom-content">
              <div className="social-links">
                <h4>Follow Us</h4>
                <div className="social-icons">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook /></a>
                  {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a> */}
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                  {/* <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a> */}
                </div>
              </div>
            </div>
            <div className="footer-legal">
              <p className="copyright">
                © {currentYear} Loan Made Easy. All rights reserved.
              </p>
              <p className="powered-by">
                Designed & Developed by <a href="https://waadii.ai/" target="_blank" rel="noopener noreferrer">Waadii.ai</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;